<template>
  <div class="col-md-12 mx-auto">
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :title="venteLot.tostring"/>
        <div>
          <button class="show-action-btn edit mr-1" @click="clickOnEditBtn()">
            <pencil-icon size="18"/>
          </button>
          <button class="show-action-btn delete" @click="clickOnDeleteBtn()">
            <trash-icon size="18"/>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <b-card class="mt-2 mb-4 shadow-sm">

            <span class="col-md-12 bold-text level-two-title main-red-color">
              {{ $t('venteLot.lotInfos') }}
            </span>

            <div class="row ml-0 mt-1">
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('venteLot.Operation') }}</div>
                  <div v-if="venteLot.operation"> {{ venteLot.operation.name }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('venteLot.OperationLot') }}</div>
                  <div v-if="venteLot.operationLot" class="d-flex">
                    <div> {{ venteLot.operationLot.tostring }}</div>
                    <span
                      :class="{'bilan-exe':venteLot.operationLot.bilanType ==='EXE','bilan-avp':venteLot.operationLot.bilanType ==='AVP'}"
                      class="bilanType-vignette">{{ venteLot.operationLot.bilanType }}</span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('venteLot.Statut') }}</div>
                  <div v-if="venteLot.statut === 'DISPONIBLE'" class="mt-2">
                    <span class="dispo p-2">
                      {{ $t('vente.lot.statut.enum.disponible') }}
                    </span>
                  </div>
                  <div v-if="venteLot.statut === 'PRE_RESERVE'" class="mt-2">
                    <span class="prereserver p-2">
                      {{ $t('vente.lot.statut.enum.prereserve') }}
                    </span>
                  </div>
                  <div v-if="venteLot.statut === 'VENDU'" class="mt-2">
                    <span class="vendu p-2">
                      {{ $t('vente.lot.statut.enum.vendu') }}
                    </span>
                  </div>
                  <div v-if="venteLot.statut === 'A_VALIDER'" class="mt-2">
                    <span class="valider p-2">
                      {{ $t('vente.lot.statut.enum.valider') }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('venteLot.Address') }}</div>
                  <div> {{ venteLot.address }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('venteLot.City') }}</div>
                  <div> {{ venteLot.city }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('venteLot.PostalCode') }}</div>
                  <div> {{ venteLot.postalCode }}</div>
                </div>
              </div>
            </div>

            <span class="col-md-12 bold-text level-two-title my-2 main-red-color">
              {{ $t('venteLot.venteInfos') }}
            </span>

            <div class="row ml-0 mt-1">
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('venteLot.Surface') }}</div>
                  <div> {{ venteLot.surface }}m²</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('venteLot.Etage') }}</div>
                  <div> {{ venteLot.etage }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('venteLot.BrutRenove') }}</div>
                  <div> {{ venteLot.brutRenove }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('venteLot.Type') }}</div>
                  <div> {{ venteLot.type }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('venteLot.LotCoPro') }}</div>
                  <div> {{ venteLot.lotCoPro }}</div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('venteLot.PrixVente') }}</div>
                  <div> {{ venteLot.prix }}€</div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('venteLot.Description') }}</div>

                  <div v-html="formatDescription(venteLot.description)"></div>

                </div>
              </div>
            </div>

            <span class="col-md-12 bold-text level-two-title my-2 main-red-color">
              {{ $t('venteLot.Documents') }}
            </span>

            <div class="row ml-0 mt-1 mb-4">
              <div v-if="documents.length === 0" class="col-md-6">
                <div class="mt-1 mb-2"> {{ $t('venteLot.aucunDocument') }}</div>
              </div>
              <div v-for="document in documents" v-else class="col-md-6">
                <div class="d-flex flex-column">
                  <b-link @click="downloadOldFile(document)"> {{ document.name }}</b-link>
                </div>
              </div>
            </div>

            <span class="col-md-12 bold-text level-two-title my-2 main-red-color">
              {{ $t('venteLot.Photos') }}
            </span>

            <div class="row ml-0 mt-1">
              <div v-if="photos.length === 0" class="col-md-6">
                <div class="mt-1 mb-2"> {{ $t('venteLot.aucunePhoto') }}</div>
              </div>
              <div v-for="(photo, index) in photos" v-else class="col-md-2 p-0 ml-3">
                <img :key="index" :src="photo.fileUrl" alt="Image preview" class="rounded"
                     height="auto"
                     width="100%"/>
              </div>
            </div>

          </b-card>
        </div>

        <div class="col-md-4">
          <b-card class="mt-2 mb-4 shadow-sm">

            <span v-if="propositions.length > 1" class="col-md-12 bold-text level-two-title main-red-color">
              {{ $t('venteLot.PropositionsAcheteur') }}
            </span>
            <span v-else class="col-md-12 bold-text level-two-title main-red-color">
              {{ $t('venteLot.PropositionAcheteur') }}
            </span>

            <div v-if="propositions.length === 0" class="mt-2 col-md-12">
              {{ $t('venteLot.AucuneProposition') }}
            </div>
            <div v-else class="row">
              <b-col v-for="(document, index) in propositions" :key="'document-' + index" class="col-md-12 px-3 mt-4">
                <div class="text-center mt-2 mb-1 ">
                  {{ agentName(document.tostring) }}
                </div>
                <div class="text-center mt-2 mb-2 ">
                  {{ agentMail(document.tostring) }}
                </div>
                <div class="text-center mt-2 mb-2">
                  {{ agentDate(document.tostring) }}
                </div>
                <div class="border rounded p-2">
                  <div
                    v-if="document.extension === '.jpg' || document.extension === '.jpeg' || document.extension === '.png'"
                    class="text-center">
                    <img :src="document.fileUrl" alt="Image preview" class="m-auto preview-image"/>
                  </div>
                  <div v-else-if="document.extension === '.pdf'" class="text-center">
                    <svg class="icon icon-tabler icons-tabler-outline icon-tabler-file-type-pdf" fill="none" height="24"
                         stroke="#9E0430" stroke-linecap="round"
                         stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24"
                         xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 0h24v24H0z" fill="none" stroke="none"/>
                      <path d="M14 3v4a1 1 0 0 0 1 1h4"/>
                      <path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"/>
                      <path d="M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6"/>
                      <path d="M17 18h2"/>
                      <path d="M20 15h-3v6"/>
                      <path d="M11 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z"/>
                    </svg>
                  </div>
                  <div v-else class="text-center">
                    <svg class="icon icon-tabler icons-tabler-outline icon-tabler-file-info" fill="none" height="24"
                         stroke="#07153C" stroke-linecap="round"
                         stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24"
                         xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 0h24v24H0z" fill="none" stroke="none"/>
                      <path d="M14 3v4a1 1 0 0 0 1 1h4"/>
                      <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"/>
                      <path d="M11 14h1v4h1"/>
                      <path d="M12 11h.01"/>
                    </svg>
                  </div>
                </div>
                <div class="text-center mt-2">
                  <b-link :href="document.fileUrl" class="main-color-text bold-text mr-3" target="_blank">
                    {{ $t('venteLot.Download') }}
                    <file-download-icon size="18"/>
                  </b-link>
                  <b-link class="secondary-color  bold-text mr-3" v-on:click="deleteProposition(document.id)">
                    {{ $t('Delete') }}
                    <x-icon size="18"/>
                  </b-link>
                </div>

                <Item-delete-modal
                  :id="'item-delete-modal-prop-' + document.id"
                  :is-feminine="true"
                  :selectedItem="document"
                  controllerName="venteLotDocument"
                  itemSingularName="proposition"
                  itemSingularNameUpp="Proposition"
                  @didDeleteItem="didDeleteProposition()">
                </Item-delete-modal>
              </b-col>
            </div>

          </b-card>
        </div>
      </div>
    </b-container>

    <Item-delete-modal
      :is-feminine="true"
      :selectedItem="this.venteLot"
      controllerName="venteLot"
      itemSingularName="vente"
      itemSingularNameUpp="Vente"
      @didDeleteItem="didDeleteVenteLot()">
    </Item-delete-modal>

  </div>

</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import ItemDeleteModal from "../../components/b122/ItemDeleteModal.vue";

export default {

  name: "VenteLotShow",

  components: {
    ItemDeleteModal,
    BackArrow
  },

  data() {
    return {
      venteLotId: this.$route.params.venteLotId,
      venteLot: {},
      photos: [],
      documents: [],
      propositions: [],
      isDeletePropositionModalVisible: false,
    }
  },

  computed: {
    getValue() {
      return property => (this.user[property] || this.user[property] === false) ? this.user[property] : 'N/A'
    },
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    formatDescription(description) {
      if (description) {
        return description.replace(/\n/g, '<br>');
      }
      return '';
    },

    agentName(text) {
      if (!text) return '';
      return text.split('-')[0].trim();
    },

    agentMail(text) {
      if (!text) return '';
      const parts = text.split('-');
      if (parts.length >= 3) {
        return parts[1].trim();
      }
      return '';
    },

    agentDate(text) {
      if (!text) return '';

      const parts = text.split('-');

      if (parts.length >= 3) {

        return parts.slice(2).join('-').trim();
      }
      return '';
    },


    downloadOldFile(file) {
      if (!file.hasOwnProperty('fileUrl')) {
        this.downloadNewFile(file)
        return
      }
      api({
        method: 'GET',
        url: file.fileUrl,
        responseType: 'blob'
      })
        .then(response => {
          let a = document.createElement('a')
          let blob = new Blob([response.data])
          let url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = file.fileName
          a.click()
          window.URL.revokeObjectURL(url)
        })
    },


    async fetchData() {
      await this.fetchVenteLot()
      await this.fetchPhotos()
      await this.fetchDocuments()
      await this.fetchPropositions()
    },

    async fetchVenteLot() {
      api
        .get(`/venteLot/${this.venteLotId}`)
        .then(response => {
          this.venteLot = response.data
        })
        .catch((error) => {
          this.$router.push({
            name: 'VenteLotIndex',
            params: {
              message: error.response.data.message
            }
          })
        })
    },



    async fetchPhotos() {
      api
        .get(`/venteLotDocument/getPhotos/${this.venteLotId}`)
        .then(response => {
          this.photos = response.data
        })
        .catch((error) => {
          this.$router.push({
            name: 'VenteLotIndex',
            params: {
              message: error.response.data.message
            }
          })
        })
    },

    async fetchDocuments() {
      api
        .get(`/venteLotDocument/getDocuments/${this.venteLotId}`)
        .then(response => {
          this.documents = response.data
        })
        .catch((error) => {
          this.$router.push({
            name: 'VenteLotIndex',
            params: {
              message: error.response.data.message
            }
          })
        })
    },

    async fetchPropositions() {
      api
        .get(`/venteLotDocument/getPropositions/${this.venteLotId}`)
        .then(response => {
          this.propositions = response.data
        })
        .catch((error) => {
          this.$router.push({
            name: 'VenteLotIndex',
            params: {
              message: error.response.data.message
            }
          })
        })
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'VenteLotCreateEdit',
        params: {
          venteLotId: this.venteLotId
        }
      })
    },

    clickOnDeleteBtn() {
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteVenteLot() {
      this.$router.push({
        name: 'VenteLotIndex'
      })
    },

    async didDeleteProposition() {
      await this.fetchData()
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    },

    async deleteProposition(id) {


      this.$bvModal.show('item-delete-modal-prop-' + id)
      // this.isDeletePropositionModalVisible = true

    },

    downloadProposition() {

    }

  }
}

</script>

<style scoped>

.dispo {
  border-radius: 30px;
  text-align: center;
  background: #06C9B3;
  color: white;
}

.prereserver {
  border-radius: 30px;
  text-align: center;
  background: #009DFF;
  color: white;
}

.valider {
  border-radius: 30px;
  text-align: center;
  background: #9E0430;
  color: white;
}

.vendu {
  border-radius: 30px;
  text-align: center;
  background: #FF9D00;
  color: white;
}

.bilanType-vignette {
  color: var(--main-white);
  text-align: center;
  font: normal normal normal 10px/13px Montserrat-Bold, "Arial", sans-serif;
  letter-spacing: 1px;
  width: 40px;
  height: 20px;
  border-radius: 4px;
  opacity: 1;
  padding: 0.5em;
  margin-left: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
}

</style>



// WEBPACK FOOTER //
// src/views/venteLot/VenteLotShow.vue